<template>
       <div class="card">
      <div class="card-header">
        <div class="card-title">{{ title }}</div>
      </div>
      <div class="card-body">
      <slot :column="column" v-bind="$attrs"></slot>
        
   </div>
   </div>
</template>

<script>
    export default {
        props: {
            title: {
                type: String,
                default: ''
            },
            column: {
                type:Number,
                default: 3
            }
        }
    }
</script>

<style lang="scss" scoped>
.card{
  margin-bottom: 20px;
  background-color: #fff;
  margin: 20px;
  border-radius: 10px;
  &-header{
    padding: 15px 20px;
    border-bottom: 1px solid #f0f0f0;
  }
  &-title{
    font-size: 16px;
    font-weight: bold;
  }
  &-body{
    padding: 15px 20px;
    display: flex;
    flex-wrap: wrap;
  }
  
}
</style>